<template>
  <div id="index" style="background-color:#D51522">
    <common-header sheen="top"></common-header>
      <img src="/static/image/top1.png" style="width:100%;max-width:800px;" alt="平成を語ろう">
      <p style="text-align:center">
        <v-layout row wrap>
          <v-flex md6 xs12>
            <v-btn dark large color="white" :to="{ name: 'Edit', params:{obj: {mode: 'new'}}}" class="red--text topBtn"><v-icon>edit</v-icon>&nbsp;年表を投稿</v-btn>
          </v-flex>
          <v-flex md6 xs12>
            <v-btn dark outline large :to="{ name: 'View'}" class="topBtn"><v-icon>search</v-icon>&nbsp;投稿を見る</v-btn>
          </v-flex>
        </v-layout>
      </p>
      <p style="text-align:center;margin-top:10px;">
        <router-link :to="{ name: 'QList'}" style="color:#fff;">募集中のお題一覧</router-link>
      </p>
      <img src="/static/image/top2.png" style="width:100%;max-width:800px;" alt="平成とは？">
      <p style="text-align:center">
        <v-layout row wrap>
          <v-flex md6 xs12>
            <v-btn dark large color="white" :to="{ name: 'Edit', params:{obj: {mode: 'new'}}}" class="red--text topBtn"><v-icon>edit</v-icon>&nbsp;年表を投稿</v-btn>
          </v-flex>
          <v-flex md6 xs12>
            <v-btn dark outline large :to="{ name: 'View'}" class="topBtn"><v-icon>search</v-icon>&nbsp;投稿を見る</v-btn>
          </v-flex>
        </v-layout>
      </p>
      <p style="text-align:center;margin-top:10px;">
        <router-link :to="{ name: 'QList'}" style="color:#fff;">募集中のお題一覧</router-link>
      </p>
      <img src="/static/image/top3.png" style="width:100%;max-width:800px;" alt="平成年表の使い方">
      <p style="text-align:center">
        <v-layout row wrap>
          <v-flex md6 xs12>
            <v-btn dark large color="white" :to="{ name: 'Edit', params:{obj: {mode: 'new'}}}" class="red--text topBtn"><v-icon>edit</v-icon>&nbsp;年表を投稿</v-btn>
          </v-flex>
          <v-flex md6 xs12>
            <v-btn dark outline large :to="{ name: 'View'}" class="topBtn"><v-icon>search</v-icon>&nbsp;投稿を見る</v-btn>
          </v-flex>
        </v-layout>
      </p>
      <p style="text-align:center;margin-top:10px;">
        <router-link :to="{ name: 'QList'}" style="color:#fff;">募集中のお題一覧</router-link>
      </p>
    <common-footer sheen="top"></common-footer>
  </div>
</template>

<script>
import CommonHeader from './common/CommomHeader'
import CommonFooter from './common/CommomFooter'
import PostButton from './common/PostButton'
import LoginPart from './auth/Login'
export default {
  name: 'Index',
  data () {
    return {
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.view.isLogin
    }
  },
  head: {
    title: function () {
      return {
        inner: '平成年表とは',
        separator: '|',
        complement: '平成年表'
      }
    },
    meta: function () {
      return [
        {name: 'twitter:title', content: '平成年表とは｜平成年表'},
        {property: 'og:title', content: '平成年表とは｜平成年表'},
        {name: 'twitter:description', content: 'サイト説明｜平成年表は平成の想い出を気軽に投稿しシェアできるサイトです。平成の想い出を年表にして投稿してみよう。'},
        {name: 'description', content: 'サイト説明｜平成年表は平成の想い出を気軽に投稿しシェアできるサイトです。平成の想い出を年表にして投稿してみよう。'},
        {name: 'twitter:image', content: 'https://www.katsulabo.com/heisei/image/heisei-nenpyo.png'},
        {property: 'og:image', content: 'https://www.katsulabo.com/heisei/image/heisei-nenpyo.png'}
      ]
    }
  },
  components: {
    CommonHeader,
    LoginPart,
    CommonFooter,
    PostButton
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("../assets/css/common.css");
.topBtnArea{
  text-align:center;
}
.topBtn{
  margin: 5px auto !important;
  width: 90% !important;
  height:50px;
  font-size:140%;
}
.block{
  margin-top: 24px;
  width: 100%;
  text-align:center;
}
.block-top{
  margin-top: 10%;
  margin-bottom: 10%;
  width: 100%;
}
.block-subtitle {
  padding:0 20px;
  margin:0 auto;
  margin-bottom:10px;
}
.topMessage {
  max-width: 80%;
  width: 900px;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue